import styled from 'styled-components'

const OptionWrapper = styled.div`
  margin-bottom: 24px;
`;

export default OptionWrapper